const startInterval = (callback, seconds) => {
    callback();
    return setInterval(callback, seconds);
}

const getAzimuth = (beforeLatLng = {lat: 35.850, lng: 128.560}, afterLatLng = {lat: 35.855, lng: 128.562}) => {

    const lat1 = beforeLatLng.lat * Math.PI / 180;
    const lat2 = afterLatLng.lat * Math.PI / 180;
    const lng1 = beforeLatLng.lng * Math.PI / 180;
    const lng2 = afterLatLng.lng * Math.PI / 180;

    const y = Math.sin(lng2 - lng1) * Math.cos(lat2);
    const x = (Math.cos(lat1) * Math.sin(lat2)) - (Math.sin(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1));
    const angle = Math.atan2(y, x);
    const bearing = (angle * 180 / Math.PI + 360) % 360;

    return Math.round(bearing)
}

const checkLocation = (location) => {
    if (location === undefined) return false;
    else if (location === null) return false;
    else if (location.lat === undefined || location.lng === undefined) return false;
    else if (location.lat === null || location.lng === null) return false;
    else if (location.lat === '' || location.lng === '') return false;
    else if (isNaN(Number(location.lat)) || isNaN(Number(location.lng))) return false;
    else if (Number(location.lat) < 33 || Number(location.lat) > 43) return false;      // 대한민국 위도 범위
    else if (Number(location.lng) < 124 || Number(location.lng) > 132) return false;    // 대한민국 경도 범위

    return true;
}

const checkLocationXY = (location) => {
    if (location === undefined) return false;
    else if (location === null) return false;
    else if (location.carX === undefined || location.carY === undefined) return false;
    else if (location.carX === null || location.carY === null) return false;
    else if (location.carX === '' || location.carY === '') return false;
    else if (isNaN(Number(location.carX)) || isNaN(Number(location.carY))) return false;
    else if (Number(location.carX) < 33 || Number(location.carX) > 43) return false;      // 대한민국 위도 범위
    else if (Number(location.carY) < 124 || Number(location.carY) > 132) return false;    // 대한민국 경도 범위

    return true;
}

export {
    startInterval,
    getAzimuth, checkLocation, checkLocationXY
}